import React, { useState } from "react";
import { Form, Input, Button, Row, Col, Card, message } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import 'antd/dist/antd.css';
import ProfileService from "../../../services/Profile/ProfileService";



const rules = {
    old_password: [
        {
            required: true,
            message: "Ju lutem, plotësoni passwordin aktual! ",
        },
    ],
    new_password: [
        {
            required: true,
            message: "Ju lutem, plotësoni passwordin e ri! ",
        },
    ],
    confirm_new_password: [
        {
            required: true,
            message: "Ju lutem, plotësoni passwordin e ri të konfirmuar! ",
        },
    ],
};



const ChangeProfilePassword = () => {
    const token = useSelector((state) => state.Member.token);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);


    const resetForm = () => {
        form.resetFields();
    };


    const formatRequestData = (data) => {
        const requestData = {
            old_password: data.old_password,
            new_password: data.new_password,
            confirm_new_password: data.confirm_new_password
        }
        return requestData;
    };


    const onSave = () => {
        setLoading(true);
        form
            .validateFields()
            .then((data) => {
                const requestData = formatRequestData(data);
                ProfileService.changePassword(token, requestData)
                    .then((response) => {
                        message.success("Fjalëkalimi u ndryshua me sukses!", 1).then(() => {
                            setLoading(false);
                            resetForm();
                        });
                    })
                    .catch((err) => {
                        const errorMessage = err.response.data.Error
                            ? err.response.data.Error
                            : "Një gabim ndodhi gjatë ndryshimit të fjalëkalimit!";
                        message.error(errorMessage, 3).then(() => {
                            setLoading(false);
                        });
                    });
            }).catch(() => { setLoading(false); });
    };



    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card style={{ backgroundColor: '#00000008', color: '#000' }} className='text-center' bodyStyle={{ padding: '15px' }}>
                            <h3 className="m-0 p-0" style={{ color: "#000" }}>Ndrysho fjalëkalimin</h3>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card>
                            <Row gutter={24}>
                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form
                                        form={form}
                                        layout="vertical"
                                    >
                                        <Row gutter={24}>
                                            <Col xl={4} lg={4} md={24} sm={24} xs={24}></Col>
                                            <Col xl={16} lg={16} md={24} sm={24} xs={24}>
                                                <Form.Item name="old_password" label="Fjalëkalimi aktual:" rules={rules.old_password}>
                                                    <Input
                                                        type="password"
                                                        // placeholder="Fjalëkalimi aktual..."
                                                    />
                                                </Form.Item>
                                                <Form.Item name="new_password" label="Fjalëkalimi i ri:" rules={rules.new_password}>
                                                    <Input
                                                        type="password"
                                                        // placeholder="Fjalëkalimi i ri..."
                                                    />
                                                </Form.Item>
                                                <Form.Item name="confirm_new_password" label="Konfirmoni fjalëkalimin e ri:" rules={rules.confirm_new_password}>
                                                    <Input
                                                        type="password"
                                                        // placeholder="Konfirmoni fjalëkalimin e ri..."
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Form>
                                    <Row gutter={24} className="mt-3">
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} className="text-center">
                                            <Button
                                                type="primary"
                                                onClick={() => onSave()}
                                                loading={loading}
                                                icon={<CheckOutlined />}
                                            >
                                                Ruaj
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default ChangeProfilePassword;